import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/$/, '');

export const apiBaseUrl = API_BASE_URL;

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

axios.defaults.baseURL = API_BASE_URL;

const transformAxiosUrl = (config) => {
  if (config.url) {
    if (config.url.startsWith('http://') || config.url.startsWith('https://')) {
      return config;
    }
    if (config.url.startsWith('/api/')) {
      config.url = config.url.slice('/api'.length);
    }
  }
  return config;
};

apiClient.interceptors.request.use(transformAxiosUrl);
axios.interceptors.request.use(transformAxiosUrl);

export const buildApiUrl = (path) => {
  if (!path) return API_BASE_URL;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('/api/')) return `${API_BASE_URL}${path.slice('/api'.length)}`;
  if (path === '/api') return API_BASE_URL;
  return `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
};

export const safeJson = async (response, fallback = null) => {
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    const text = await response.text();
    return {
      ok: false,
      status: response.status,
      data: null,
      rawBody: text,
    };
  }

  try {
    return {
      ok: true,
      status: response.status,
      data: await response.json(),
      rawBody: null,
    };
  } catch (error) {
    return {
      ok: false,
      status: response.status,
      data: fallback,
      rawBody: null,
      error,
    };
  }
};

export const apiJson = async (path, options = {}, fallback = null) => {
  const response = await fetch(buildApiUrl(path), options);
  const parsed = await safeJson(response, fallback);

  if (!response.ok) {
    const detail =
      parsed.data?.detail ||
      parsed.data?.message ||
      parsed.rawBody ||
      `HTTP ${response.status}`;
    throw new Error(detail);
  }

  return parsed.data;
};
